import { useEffect } from 'react';
import {
  Control,
  UseFormRegister,
  UseFormSetValue,
  FieldErrors,
} from 'react-hook-form';
import { Grid, FormControl, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MexicoStakeHoldersFormData } from '../../types/stakeholders.type';

interface FlexibleAddressProps {
  data?: MexicoStakeHoldersFormData;
  errors: FieldErrors<MexicoStakeHoldersFormData>;
  control: Control<MexicoStakeHoldersFormData>;
  register: UseFormRegister<MexicoStakeHoldersFormData>;
  setValue: UseFormSetValue<MexicoStakeHoldersFormData>;
}

const FlexibleAddress = ({
  register,
  errors,
  setValue,
  data,
}: FlexibleAddressProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    setValue('postCode', data?.postCode ?? '');
  }, [setValue, data?.postCode]);

  return (
    <>
      <Grid item xs={12} md={6}>
        <FormControl fullWidth>
          <Typography variant="subtitle2">{t('onbCity')}</Typography>
          <TextField
            autoComplete="off"
            type="text"
            error={!!errors.city}
            className="custom-textfield w-full"
            size="small"
            {...register('city', {
              required: true,
            })}
          />
          {errors.city?.type === 'required' && (
            <p className="text-orange-600 text-xs mt-1">
              {t('onbCityRequired')}
            </p>
          )}
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControl fullWidth>
          <Typography variant="subtitle2">{t('onbState')}</Typography>
          <TextField
            autoComplete="off"
            type="text"
            error={!!errors.state}
            className="custom-textfield w-full"
            size="small"
            {...register('state', {
              required: true,
            })}
          />
          {errors.state?.type === 'required' && (
            <p className="text-orange-600 text-xs mt-1">
              {t('onbStateRequired')}
            </p>
          )}
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControl fullWidth>
          <Typography variant="subtitle2">{t('onbZipCode')}</Typography>
          <TextField
            autoComplete="off"
            type="text"
            error={!!errors.postCode}
            className="custom-textfield w-full"
            size="small"
            {...register('postCode', {
              required: true,
            })}
          />
          {errors.postCode?.type === 'required' && (
            <p className="text-orange-600 text-xs mt-1">
              {t('onbZipCodeRequired')}
            </p>
          )}
        </FormControl>
      </Grid>
    </>
  );
};

export default FlexibleAddress;
